<template>
    <div id="results">
        <v-container class="text-center">
            <div v-if="items.length > 0">
                <v-row v-for="item in items" :key="item.id" class="search-item" align="center" justify="center">
                    <v-col cols="12" md="4">
                        <h3><router-link :to="{ name: 'betrieb-detail', params: {id: item.id} }">{{ item.title }}</router-link></h3>
                        <p>{{ item.street }}<br>
                            {{ item.postcode }} {{ item.city }}</p>

                    </v-col>
                    <v-col cols="12" md="4">
                        <div>
                            <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                            <span v-if="item.web"><br><a :href="`${item.web}`" target="_blank">{{ item.web }}</a></span>
                        </div>
                        <div v-if="item.shop">
                            <strong>Shop:</strong> <a :href="`${item.shop}`" target="_blank">{{ item.shop }}</a>
                        </div>
                        <p v-if="item.tags" class="tags">
                            {{ item.tags }}
                        </p>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div><span v-if="item.phone"><v-icon>fas fa-phone-alt</v-icon> <a :href="`tel:${item.phone}`">{{ item.phone }}</a></span>
                            <span v-if="item.mobile"><br><v-icon>fas fa-mobile-alt</v-icon> <a :href="`tel:${item.mobile}`">{{ item.mobile }}</a></span></div>
                    </v-col>
                </v-row>
            </div>
            <div v-else>
                <p>Keine Einträge gefunden.</p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "Search",
        props: ['items', 'visible'],
    }
</script>

<style scoped>

</style>